import React, {createRef, useContext, useEffect, useState} from 'react';
import {Avatar, Grid, Paper, Tooltip, withStyles} from "@material-ui/core";
import __ from 'lodash';
import {
  Icon,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide
} from '@material-ui/core';

import {Alert} from "./";
import SystemContext from '../SystemContext';
import Draggable from "react-draggable";

const PaperComponent = (props) => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FormDialog = (props) => {
  const formRef = createRef();
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const [record, setRecord] = useState(props.record||{});
  const [state, setState] = useState({open:false, error: false, errorMessage: null, propsAlert: JSON.stringify(props.alert)});
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: "",
    ...props.alert
  });

  if (JSON.stringify(props.alert) !== state.propsAlert) {
    setAlert({
      open: false,
      severity: "error",
      message: "",
      ...props.alert
    });
    setState({...state,  propsAlert: JSON.stringify(props.alert)});
  }

  if (state.open !== props.open) {
    setState({...state, open: props.open});
    setRecord({...props.record});
  }

  const defaultButtons = {
    save:{icon: "check_circle", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
    cancel:{icon: "cancel", label: "Cancel", color: "primary"}
  };

  const title = props.title||'';
  const message = props.message;
  const buttons = props.buttons? {...props.buttons}:{...defaultButtons};
  const onChange = props.onChange;
  const Validator = props.validator;
  const validatorPosition = props.validatorPosition || "bottom";
  const validatorExtraData = props.validatorExtraData;
  const formId = props.formId || (typeof props.title==="string"?props.title.replace(/\s/g, ''):'form');
  const formMovable = props.movable;
  const titleBarStyle = props.titleBarStyle || {};
  const onRecordChange = props.onRecordChange;

  const changeButtonState = (changes) => {
    eventBus.trigger(`FormDialog.${formId}.changeButtonState`, changes);
  }

  const recordChange = (changes, replace=false) => {
    const newRecord = replace===true?{...changes}:{...record, ...changes};
    setRecord(newRecord);
    if (onRecordChange) {
      onRecordChange(newRecord);
    }
  }

  const buttonHandler = (buttonPressed) => {
    if (buttonPressed === "cancel") {
      onChange({buttonPressed, record: props.record, oldRecord: props.record, formRef, recordChange});
    } else {
      onChange({buttonPressed, record, oldRecord: props.record, formRef, recordChange});
    }
  }

  let keyId = 0;
  const usedKeys = {}
  const getKey = (id, name) => {
    let key = id || name || `_field(${++keyId})`;
    if (usedKeys[key]) {
      key = `_field(${++keyId})`;
    }
    usedKeys['key'] = true;
    return key;
  }

  const changeRecord = (changes) => {
    const newRecord = {...record, ...changes};
    setRecord(newRecord);
  }

  const defaultsRecord = {};
  const addOnChangeToChildren = (_child, i = 0) => {
    let child = _child;
    if (typeof child === 'function') {
      child = _child(record, changeRecord, changeButtonState);
    }
    if (Array.isArray(child)) {
      return child.map(addOnChangeToChildren);
    }
    if (!child || !child.props) return child;
    const childsOnChange = child.props.onChange;
    const onRecordChange = props.onRecordChange;
    const id=getKey(child.props.id, child.props.name);

    const internalElement = (typeof child.type === "string" && child.type.substring(0,1) === child.type.substring(0,1).toLowerCase());
    if (child.props && child.props.children && (internalElement || child.props.checkChildren || child.props.checkchildren)){
      if (Array.isArray(child.props.children)){
        const children = child.props.children.map(addOnChangeToChildren);
        const { checkChildren, ...childProps } = child.props;
        const filteredChild = { ...child, props: childProps }
        const changes = {};
        if (!internalElement && !childProps.key) {
          changes['key']=`form_field_${id}`;
        }
        return React.cloneElement(filteredChild, {...changes}, children);
      } else {
        const children = addOnChangeToChildren(child.props.children);
        const { checkChildren, ...childProps } = child.props;
        const filteredChild = { ...child, props: childProps }
        const changes = {};
        if (!internalElement && !childProps.key) {
          changes['key']=`form_field_${id}`;
        }
        return React.cloneElement(filteredChild, {...changes}, [children]);
      }
    }

    if (props.open) {
      const changes = {
        onChange: (e)=>{
          let value = e;
          if (e && e.target) {
            value = e.target.type==='checkbox'?e.target.checked:e.target.value;
          }
          if (child.props && typeof child.props.beforeChange === "function") {
            value = child.props.beforeChange(value);
          }

          const formOnChange = (value) => {
            const newRecord = {...record};
            newRecord[id] = value;
            setRecord(newRecord);
            if (onRecordChange) {
              onRecordChange(newRecord);
            }
          }

          const recordChange = (changes, replace=false) => {
            const newRecord = replace===true?{...changes}:{...record, ...changes};
            setRecord(newRecord);
            if (onRecordChange) {
              onRecordChange(newRecord);
            }
          }

          if (childsOnChange) {
            childsOnChange(value, {onChange: formOnChange, recordChange, record});
          } else {
            formOnChange(value);
          }
        }
      };
      if (child && child.props && child.props.formDialog && child.props.formDialog.addRecordChange) {
        const recordChange = (changes, replace=false) => {
          const newRecord = replace===true?{...changes}:{...record, ...changes};
          setRecord(newRecord);
          if (onRecordChange) {
            onRecordChange(newRecord);
          }
        }
        changes['recordChange'] = recordChange;
      }

      if (record[id] === undefined && child.props.defaultValue !== undefined) {
        defaultsRecord[id] = child.props.defaultValue;
      }
      changes['value'] = record[id]===null||record[id]===undefined?"":record[id];
      changes['checked'] = record[id]===null||record[id]===undefined?"":record[id];
      if (!Object.prototype.hasOwnProperty.call(child.props, 'key')) {
        changes['key'] = getKey(child.props.id, child.props.name);
      }

      const { checkChildren, ...childProps } = child.props;
      const filteredChild = { ...child, props: childProps }
      const newChild = React.cloneElement(filteredChild, {...changes});
      return newChild;
    }
  }
  let children = null;
  if (props.children && props.open) {
    if (Array.isArray(props.children)){
      children = props.children.map(addOnChangeToChildren);
    } else {
      children = addOnChangeToChildren(props.children);
    }
    if (Object.keys(defaultsRecord).length > 0) {
      const newRecord = {...record, ...defaultsRecord};
      setRecord(newRecord);
      if (props.onRecordChange) {
        props.onRecordChange(newRecord);
      }
    }
  }

  // const Form = (props) => (
  //   <div type="form" {...(__.omit(props, ['children']))}>{props.children}</div>
  // )

  useEffect(()=> {
    const onRecordChange = props.onRecordChange;
    const recordChange = (changes, replace=false) => {
      const newRecord = replace===true?{...changes}:{...record, ...changes};
      setRecord(newRecord);
      if (onRecordChange) {
        onRecordChange(newRecord);
      }
    }
    const handleRecordChange = ({changes, onChangeHandler}) => {
      if (onChangeHandler) {
        onChangeHandler(changes, {recordChange, record});
      } else {
        recordChange(changes);
      }
    }
    eventBus.bind(`FormDialog.${formId}.changeRecord`, handleRecordChange);

    return ()=> {
      eventBus.unbind(`FormDialog.${formId}.changeRecord`, handleRecordChange);
    }
  },[eventBus, formId, props.onRecordChange, record]);


  const ButtonBar = (props) => {
    const buttons = props.buttons;
    const [buttonStates, setButtonStates] = useState({});

    useEffect(()=> {
      const handleChangeButtonState = (changes) => {
        setButtonStates({...buttonStates, ...changes});
      }
      eventBus.bind(`FormDialog.${formId}.changeButtonState`, handleChangeButtonState);

      return ()=> {
        eventBus.unbind(`FormDialog.${formId}.changeButtonState`, handleChangeButtonState);
      }
    },[buttonStates]);

    return (
      <>
        {Object.entries(buttons).map(([key, buttonProps]) => {
          const button = __.omit(buttonProps,['label', 'icon', 'iconOptions', 'onClick', 'disabled', 'hidden', 'startIcon']);
          const iconOptions = {color:"primary", ...props.iconOptions};
          const buttonState = {
            disabled: false,
            hidden: false,
            ...buttonStates[key]
          }
          button['onClick'] = ()=>buttonHandler(key);
          if (typeof buttonProps.hidden === "function") {
            button['hidden'] = buttonProps.hidden({record, error:state.error, errorMessage:state.errorMessage, buttonState});
          } else {
            button['hidden'] = buttonProps.hidden || buttonState.hidden;
          }
          if (typeof buttonProps.disabled === "function") {
            button['disabled'] = buttonProps.disabled({record, error:state.error, errorMessage:state.errorMessage, buttonState});
          } else {
            button['disabled'] = buttonProps.disabled || buttonState.disabled;
          }
          iconOptions['hidden'] = button.hidden;
          iconOptions['disabled'] = button.disabled;
          if (iconOptions.disabled) {
            iconOptions['color']=undefined;
          }

          if (buttonProps.icon) {
            button['startIcon'] = (<Icon {...iconOptions}>{buttonProps.icon}</Icon>);
          }

          return (
            button.hidden?null:
            <Button {...button}>
              {buttonProps.label}
            </Button>
          )
        })}
      </>
    )
  }


  return (
    <div>
      <Dialog id="form-dialog-slide"
              className="CmsFormDialog"
              style={{zIndex: props?.zIndex||1000}}
              open={props.open}
              TransitionComponent={Transition}
              keepMounted
              onClose={()=>buttonHandler(props.closeValue===undefined?false:props.closeValue)}
              aria-labelledby="form-dialog-slide-title"
              aria-describedby="form-dialog-slide-description"
              disableBackdropClick={true}
              PaperComponent={formMovable ? PaperComponent : undefined}
              aria-labelledby="draggable-dialog-title"
              {...props.dialogOptions}
      >
        <DialogTitle style={{ cursor: formMovable ? 'move' : undefined}} id="draggable-dialog-title" >
        {/*<DialogTitle id="form-dialog-slide-title">*/}
          <div style={{clear: "both", backgroundColor:'primary', padding:"10px", ...titleBarStyle}}>
          {typeof title==="function"?title(record):title}
          </div>
        </DialogTitle>
        <Alert
          key="alert"
          onChange={(open) => {
            setAlert({ ...alert, open })
          }}
          open={alert.open}
          severity={alert.severity}
          message={alert.message}
          timeOut={alert.timeOut || 0}
        />
        {Validator && validatorPosition === "top"
          ? <Validator
            record={record}
            extraData={validatorExtraData}
            onChange={status=>{
              setTimeout(()=>{setState({...state, ...status});}, 1)
            }
            }/>
          :<></>
        }
        {message && props.messageAboveScroll
          ?
            <DialogContentText id="form-dialog-slide-description" style={{marginLeft: 30, fontWeight: 500}}>
              {message}
            </DialogContentText>
          : <></>
        }
        <DialogContent>
          {props.messageAboveScroll === undefined || !props.messageAboveScroll
            ?
              <DialogContentText id="form-dialog-slide-description">
                {message}
              </DialogContentText>
            : <></>
          }
          <div ref={formRef}>
            {children}
          </div>
          <div style={{height: 10, minHeight:10, maxHeight:10}}/>
        </DialogContent>
        {Validator && validatorPosition === "bottom"
          ? <Validator
            record={record}
            extraData={validatorExtraData}
            onChange={status=>{
              setTimeout(()=>{setState({...state, ...status});}, 1)
            }
            }/>
          :<></>
        }
        <DialogActions>
          <ButtonBar buttons={buttons}/>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default FormDialog;
